import React from 'react';
import ReactDOM from 'react-dom';
import JournalApp from './JournalApp';
import "./sass/main.scss";

ReactDOM.render(
  <JournalApp />,
  document.getElementById('root')
);


